import { Component, inject, OnInit } from '@angular/core';

import { RouterService } from '@services/router.service';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  private readonly routerService = inject(RouterService);

  ngOnInit(): void {
    this.routerService.onChangeRoute();
  }
}
